import { officers, roles } from "../constants/committees";
import { Card } from "../components/Card";

export default function Committees() {
  return (
    <>
      <h1>Committees</h1>
      <Card id="committeeofficers" className="committeeofficers" bgc="fill" title="Reunion Officers - 2025">
        <OfficeList src={officers} title=""/>
      </Card>
      <Card id="committeeroles" className="committeeroles" bgc="fill" title="Reunion Individual/Family Responsibilities - 2025">
        <OfficeList src={roles} title=""/>
      </Card>
    </>
  );
}

function OfficeList({ src }) {
  return (
    <ul className="dottedlist">
      {src.map((role, index) => (
        <li key={index}>
          <span className="role">{role.title}</span>
          <span className="names">
            {role.names.map((name, idx) => (
              <span key={idx}>{name}</span> 
            ))}
          </span>
        </li>
      ))}
    </ul>
  )
}